import { translate } from '../translate';

export const getHotelSubtitleTranslation = (guests: number, checkIn: string, checkOut: string) => {
  if (guests <= 0) return '';

  const translationContext = { guests, checkIn, checkOut };

  switch (guests) {
    case 1:
      return translate('ktxtDayView_Accommodations_Pricing1GuestsInDateRange', translationContext);
    case 2:
      return translate('ktxtDayView_Accommodations_Pricing2GuestsInDateRange', translationContext);
    case 3:
      return translate('ktxtDayView_Accommodations_Pricing3GuestsInDateRange', translationContext);
    case 4:
      return translate('ktxtDayView_Accommodations_Pricing4GuestsInDateRange', translationContext);
    case 5:
      return translate('ktxtDayView_Accommodations_Pricing5GuestsInDateRange', translationContext);
    case 6:
      return translate('ktxtDayView_Accommodations_Pricing6GuestsInDateRange', translationContext);
    case 7:
      return translate('ktxtDayView_Accommodations_Pricing7GuestsInDateRange', translationContext);
    case 8:
      return translate('ktxtDayView_Accommodations_Pricing8GuestsInDateRange', translationContext);
    case 9:
      return translate('ktxtDayView_Accommodations_Pricing9GuestsInDateRange', translationContext);
    default:
      return translate('ktxtDayView_Accommodations_PricingXGuestsInDateRange', translationContext);
  }
};
